import { render } from "./ReceiverEmptyState.vue?vue&type=template&id=852ebfa2&scoped=true"
import script from "./ReceiverEmptyState.vue?vue&type=script&lang=js"
export * from "./ReceiverEmptyState.vue?vue&type=script&lang=js"

import "./ReceiverEmptyState.vue?vue&type=style&index=0&id=852ebfa2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852ebfa2"],['__file',"src/scripts/view/review/components/ReceiverEmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "852ebfa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('852ebfa2', __exports__)) {
    api.reload('852ebfa2', __exports__)
  }
  
  module.hot.accept("./ReceiverEmptyState.vue?vue&type=template&id=852ebfa2&scoped=true", () => {
    api.rerender('852ebfa2', render)
  })

}


export default __exports__